class World extends View {
    constructor(worldData, dat) {
        super(dat);
        this.data = worldData;
        this.backgroundImage = "images/"+worldData.background;
        this.waypoint = 0;
        this.wayData = wayData = {};
        this.player = new Player("player", {x:worldData.waypoints[0].x, y:worldData.waypoints[0].y});
        this.add(this.player);
        this.xp = new XP("Test",{font:"Coiny", fontSize:40,color:"yellow", shadowColor:"black",x:0,y:0});
        this.add(this.xp);
    }

    moveToNextWaypoint() {
        this.waypoint++;
        if (this.waypoint==this.data.waypoints.length) this.waypoint = 0;
        this.wayData = wayData = this.data.waypoints[this.waypoint];
        this.player.startMoving();
        if (xp>0) {
            this.xp.show("XP + "+xp);
            xp = 0;
        }
        this.player.animate({x:this.wayData.x, y:this.wayData.y}, 4, function(o) {
            o.stopMoving();
            game.states.setState("VIDEO");
        }.bind(this))

    }
    update(delta) {
        this.xp.x = this.player.x;
        this.xp.y = this.player.y;  // + this.xp.off;
    }
}

class WorldContainer extends View {
    constructor(worldData, dat) {
        super(dat);
        this.data = worldData;
        this.world = new World(worldData, merge(dat, {y:0,height:1280, backgroundColor:"red", handle:{x:0.5,y:0}}));
        this.add(this.world);
        this.maxHeight = 1280-this.height;
        this.title = new Text(worldData.name, {font:"Coiny", shadowColor:"black", x:X,y:32,fontSize:60, color:"yellow", strokeColor:"black", strokeWidth:3})
        this.add(this.title);
    }
    update(delta) {
        var target = this.world.player.y - (this.height/2);
        target = -target;
        this.world.y += (target-this.world.y) * 1*delta;
        if (this.world.y < -this.maxHeight) this.world.y = -this.maxHeight;
        if (this.world.y>0) this.world.y = 0;

    }
    moveToNextWaypoint(delay) {
        delay = delay || 0;
        setTimeout(function() {
            this.world.moveToNextWaypoint();    
        }.bind(this), delay);
        
    }
}

class Player extends Sprite {
    constructor(path, dat) {
        super(path, dat);
        this.moving = false;
        this.timer = 0.1;
        this.scale = 0.7;
    }
    rot() {
        this.animate({rotation:randomInt(-10,10)/100}, 0.1, function(o) {
            o.rot();
        });
    }
    startMoving() {
        this.moving = true;
        this.rot();
    }
    stopMoving() {
        this.moving = false;
        this.stop().animate({rotation:0},0.5);
    }
    update(delta) {
        //if (this.moving) {
        //    this.rotation = randomInt(-10,10)/100;
        //}
    }
}

class XP extends Text {
    constructor(txt, dat) {
        super(txt, dat);
        this.text = "test";
        //this.visible = false;
        this.off = 0;
        this.align = "left";
    }
    show(txt) {
        this.text = txt;
        this.off = 0;
        this.visible = true;
    }
    _update(delta) {
        if (this.visible) {
            this.off-=10*delta;
            if (this.off<-100) {
                this.visible = false;
            }
        }
    }
}